import React from 'react';

export const tabbable = {'tabIndex': 0};
export const untabbable = {'tabIndex': -1};
